import { render, staticRenderFns } from "./ServicesForm.vue?vue&type=template&id=084b44ca&"
import script from "./ServicesForm.vue?vue&type=script&lang=js&"
export * from "./ServicesForm.vue?vue&type=script&lang=js&"
import style0 from "./ServicesForm.vue?vue&type=style&index=0&id=084b44ca&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports